import { skills } from '../data/skills';

export default function AboutMe() {
  const quickFacts = [
    { label: 'Role', value: 'AI Integrations Engineer' },
    { label: 'Focus', value: 'LLMs + Automation' },
    { label: 'Research', value: 'Memory + Emotion' },
    { label: 'Location', value: 'Toronto' }
  ];

  const skillChips = skills.aboutme;

  return (
    <section id="AboutMe" className="about-section">
      <div className="about-container fade-in-visible">
        <div className="about-content">
          <div className="about-text">
            <div className="about-title about-fade-1">
              <span className="text-content">About me</span>
            </div>
            <p className="about-lead about-fade-2">
              I build practical AI products that move from prototype to production.
            </p>
            <div className="about-facts about-fade-2">
              {quickFacts.map((fact) => (
                <div key={fact.label} className="about-fact-card">
                  <span className="fact-label">{fact.label}</span>
                  <span className="fact-value">{fact.value}</span>
                </div>
              ))}
            </div>
            <p className="about-description about-fade-3">
              I am currently an <span className="highlight">AI Integrations Engineer</span> at <span className="highlight">Northbridge</span>, where I design and build AI-driven tools that automate and enhance business processes. My work ranges from rapid prototypes to production-ready systems integrating large language models (LLMs) and enterprise data.
            </p>
            <p className="about-description skills-intro about-fade-3">
              Here are some technologies I have been working with recently:
            </p>
            <div className="about-skills about-fade-4">
              <div className="skills-chip-wrap">
                {skillChips.map((skill) => (
                  <span key={skill} className="skill-chip">{skill}</span>
                ))}
              </div>
            </div>
            <p className="about-description about-fade-4">
              Outside of work, I explore how emotions influence memory and frequency effects, combining cognitive science and data modeling. I am drawn to projects that connect technical precision with psychological insight.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
